import { CTA_ICON, DEVICE_TYPE } from "src/module/const";
import style from "./changeFloatingCta.css";

const kzs = window.kzs;
const $ = kzs.$;

export const changeFloatingCta = (): void => {
  console.log("variations/changeFloatingCta");

  style.use();

  const deviveType = kzs.navigator.getDeviceType();
  $("body").addClass(deviveType == DEVICE_TYPE.sp ? "kz-sp" : "kz-pc");

  if (deviveType == DEVICE_TYPE.sp) {
    // 表示切り替え、並び替え
    $(".trac_menu img[alt=オンライン商談]").closest("li").hide();
    $(".trac_menu img[alt=カタログ請求]").closest("li").hide();
    $(".trac_menu img[alt='お問い合わせ/よくある質問']").closest("li").hide();
    $(".trac_menu ul.cf").prepend($(".trac_menu img[alt=販売店検索]").closest("li"));

    // ラインアップ
    const $lineup = $(".trac_menu img[alt=販売店検索]").closest("li");
    $lineup.find("img").hide();
    $lineup
      .find("a")
      .attr("href", "https://sp.subaru.jp/carlineup/?=splineup")
      .attr("aria-label", "ラインアップ")
      .append($("<img>", { class: "kz-cta-img", src: CTA_ICON.lineup.white }))
      .append($("<span>", { class: "kz-cta-label" }).text("ラインアップ"));

    // 見積りシミュレーション
    const $estimate = $(".trac_menu img[alt=見積りシミュレーション]").closest("li");
    $estimate.find("img").hide();
    $estimate
      .find("a")
      .attr("href", "https://members.subaru.jp/estimate_simulation/")
      .append($("<img>", { class: "kz-cta-img", src: CTA_ICON.estimateSim.white }))
      .append($("<span>", { class: "kz-cta-label" }).html("見積り<br/>シミュレーション"));

    // 試乗車検索/予約
    const $drivecar = $(".trac_menu img[alt='試乗車検索/予約']").closest("li");
    $drivecar.find("img").hide();
    $drivecar
      .find("a")
      .attr("href", "https://ap.subaru.jp/search/drivecar.html")
      .append($("<img>", { class: "kz-cta-img", src: CTA_ICON.searchDrivecar.white }))
      .append($("<span>", { class: "kz-cta-label" }).html("試乗車<br/>検索/予約"));

    // 初期表示
    $(".kz-sp .trac_menu").hide();
    $(window).off("scroll.firstView");
    $(window).one("scroll.firstView", () => {
      $(".kz-sp .trac_menu").fadeIn();
    });
  } else {
    // PC
    const CtaButton = (href?: string, label?: string, src?: string, targetBlank = true): string => {
      // target 属性の値を、targetBlank の値に応じて "_blank" または "_self" に設定
      const target = targetBlank ? "_blank" : "_self";

      const button = `
    <a href="${href}" target="${target}" aria-label="${label}" class="kz-cta-btn">
      <img  class="kz-cta-btn--icon" src="${src}" width="60" height="47" alt="${label}">
      <span class="kz-cta-btn--label">${label}</span>
    </a>
  `;
      return button;
    };

    const $wrap = $(`<div class='kz-cta-btn-wrap--floating'>`);
    $wrap
      .append(CtaButton("https://www.subaru.jp/carlineup/?=pclineup", "ラインアップ", CTA_ICON.lineup.white, false))
      .append(
        CtaButton(
          "https://members.subaru.jp/estimate_simulation/",
          "見積りシミュレーション",
          CTA_ICON.estimateSim.white
        )
      )
      .append(CtaButton("https://ap.subaru.jp/search/drivecar.html", "試乗車予約", CTA_ICON.searchDrivecar.white));

    // フローティングボタン
    $("#sc-footer").append($wrap);

    // フローティングメニュー表示制御
    $("#side_cv").hide();
    $(".kz-cta-btn-wrap--floating").hide();
    $(window).off("scroll.firstView");
    $(window).on("scroll.firstView", () => {
      if ($(".kz-cta-btn-wrap--floating").hasClass("show")) return;

      const $kz1stViewCta = $("#contents_lineup").closest("div");
      const kz1stViewCtaOffset = $kz1stViewCta.offset()?.top || 0;

      const scrollPos = $(window).scrollTop() || 0;
      const wh = $(window).height() || 0;

      if (scrollPos > kz1stViewCtaOffset - wh) {
        $(".kz-cta-btn-wrap--floating").fadeIn().css("display", "flex");
        $(".kz-cta-btn-wrap--floating").addClass("show");
      }
    });
  }
};
